import { ChakraProvider, HStack, Icon, Link, Text } from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import FraudCard from "./FraudCard";

export default function JoshuaKochPage() {
  // Using joshua1.png image as requested

  return (
    <ChakraProvider>
      <FraudCard
        fraudsterName="Joshua Stuart Koch (Josh S. Koch)"
        fraudsterImage={require("../assets/joshua1.png")}
        estimatedMoneyLost="$550K - 2M"
        socialMediaLinks={
          <HStack spacing={4} mt={2}>
            <Link
              href="https://www.linkedin.com/in/josh-s-koch-0529379b"
              isExternal
            >
              <Icon as={FaLinkedin} boxSize={6} color="blue.500" />
              <Text>LinkedIn Profile</Text>
            </Link>
          </HStack>
        }
        fraudsterDescription={
          <Text>
            Joshua Koch (Josh S. Koch) is a con-artist, a fraudster who
            committed many defrauding and money laundering crimes. <br /> <br />
            Information presented here is based on available evidence and
            ongoing investigations. Act with extreme caution. You have been
            warned.
          </Text>
        }
        partners={[
          {
            name: (
              <RouterLink to="/" style={{ textDecoration: "none" }}>
                <Text
                  display="inline"
                  color="blue.600"
                  _hover={{
                    color: "blue.800",
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                  transition="all 0.2s ease-in-out"
                >
                  Mario Grasbock
                </Text>
              </RouterLink>
            ),
          },

          {
            name: "Rafael Lopes Brasileiro Martim",
          },
        ]}
        techniques={[
          "Promises of high returns with minimal risk",
          "Name-dropping wealthy connections",
          "Pressure to invest quickly without due diligence",
          "Vague explanations about investment mechanisms",
        ]}
        images={[
          require("../assets/joshua1.png"),
          require("../assets/joshua2.png"),
        ]}
      />
    </ChakraProvider>
  );
}
